import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import LegalLinks from '@/components/legal/LegalLinks';
import { LEGAL_ENTITY } from '@/constants/legalEntity';

/** Public self-registration is disabled; teachers are onboarded by us, students by teacher invite. */
const SignupPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Access — {LEGAL_ENTITY.productName}</title>
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-violet-50/30 to-slate-50 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-lg bg-white border border-slate-200 rounded-2xl p-8 shadow-lg">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Invite-only access</h1>
          <p className="text-slate-600 text-sm leading-relaxed mb-4">
            {LEGAL_ENTITY.productName} does not offer open registration on this website.
          </p>
          <ul className="text-sm text-slate-600 space-y-3 mb-6 list-disc pl-5">
            <li>
              <strong>Music teachers &amp; schools</strong> — We create your studio account after onboarding.
              Contact us at{' '}
              <a href={`mailto:${LEGAL_ENTITY.contactEmail}`} className="text-violet-700 hover:underline">
                {LEGAL_ENTITY.contactEmail}
              </a>{' '}
              or via the contact form.
            </li>
            <li>
              <strong>Students</strong> — Your teacher sends you an invitation by email or link. Use that link
              to create your student login.
            </li>
          </ul>
          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <Button asChild className="flex-1">
              <Link to="/contact">Contact us (teachers)</Link>
            </Button>
            <Button asChild variant="outline" className="flex-1">
              <Link to="/how-it-works">How it works</Link>
            </Button>
          </div>
          <p className="text-sm text-slate-500 text-center">
            Already have an account?{' '}
            <Link to="/login" className="text-violet-700 font-medium hover:underline">
              Log in
            </Link>
          </p>
          <div className="mt-8 pt-6 border-t border-slate-200">
            <LegalLinks className="justify-center text-xs" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupPage;
